import { render } from "./edit.vue?vue&type=template&id=40cb5a3a"
import script from "./edit.vue?vue&type=script&lang=ts"
export * from "./edit.vue?vue&type=script&lang=ts"
script.render = render

export default script